import { render, staticRenderFns } from "./FrzChamberPrePacking.vue?vue&type=template&id=3afff8eb"
import script from "./FrzChamberPrePacking.vue?vue&type=script&lang=js"
export * from "./FrzChamberPrePacking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports